const questions = [
  {
    key: 'account',
    title: 'Création du compte sur spiadi.fr',
    subtitle: 'choix du mot de passe, ouverture du compte, ...',
    style: 'base',
    mandatory: true
  },
  {
    key: 'ergo',
    title: 'Ergonomie du site internet',
    subtitle: `simplicité d'utilisation, contenu, bugs, ...`,
    style: 'base',
    mandatory: true
  },
  {
    key: 'documents',
    title: 'Accès aux documents',
    subtitle: 'protocoles, fiches, charte, annexes, ...',
    style: 'doc'
  },
  {
    key: 'protocols',
    title: `Facilité d'utilisation des protocoles`,
    subtitle: 'définitions, inclusion des patients, ...',
    style: 'doc'
  },
  {
    key: 'sheets',
    title: 'Saisie des fiches',
    subtitle: 'hors fiche établissement',
    style: 'sheets'
  },
  {
    key: 'etab',
    title: 'Saisie de la fiche établissement',
    subtitle: 'récupération des données, saisie sur le site, ...',
    style: 'sheets'
  },
  {
    key: 'valid',
    title: 'Clôture de la surveillance',
    subtitle: 'validation des fiches, écran de clôture, ...',
    style: 'sheets'
  },
  {
    key: 'convention',
    title: `Validation de la charte d'engagement`,
    subtitle: 'obtention des signatures, envoi de la charte, ...',
    style: 'sheets'
  },
  {
    key: 'contact',
    title: `Qualité du contact avec l'équipe SPIADI`,
    subtitle: 'par e-mail ou par téléphone',
    style: 'com'
  },
  {
    key: 'com',
    title: `Qualité de la communication`,
    subtitle: `réunions d'informations, e-mails d'informations...`,
    style: 'com'
  }
]

const keys = [ 'overall' ]
questions.forEach(q => { keys.push(q.key) })

export default {
  questions: questions,
  keys: keys,

  star: {
    border: {
      width: 3,
      color: '#3333335a'
    },

    glow: 8,
    size: 25,
    big: 35,

    points: [
      23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23,
      43, 38, 50, 36, 34, 46, 19, 31, 17
    ]
  }
}
